<template>
  <div>
    <Card>
      <Row>
        <!-- <Button type="info"
                @click="add">新增</Button> -->
      </Row>
      <TablePaginate :columns="columns"
                     :data="products"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapActions, mapMutations, mapGetters } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { tableAvatar, booleanChinese, commonButtonInTable } from '@/libs/table-render'
export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_165'),
          key: 'image',
          align: 'center',
          render: (h, params) => {
            return tableAvatar(h, params.row.image)
          }
        },
        {
          title: i18n.t('pages_ai_image_158'),
          key: 'name',
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_166'),
          key: 'lingshoujia',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_167'),
          key: 'huiyuanjia',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_ai_thirdparty_168'),
          key: 'need_to_weight',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.need_to_weight)
          }
        },
        {
          title: i18n.t('pages_ai_thirdparty_169'),
          key: 'is_display',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.is_display)
          }
        },
        {
          title: i18n.t('pages_ai_thirdparty_170'),
          key: 'discount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.discount)
          }
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const children = []
            children.push(commonButtonInTable(
              this,
              h,
              'warning',
              i18n.t('pages_ai_thirdparty_171'),
              this.delete_label,
              [params.row]
            ))
            return h('div', children)
          }
        }
      ],
    }
  },
  created () {
    this.resetQuery()
    this.productIndex({ is_display: 'ignore' })
  },
  computed: {
    ...mapGetters('product', ['products', 'loading', 'meta']),
  },
  methods: {
    ...mapActions('ai', [
      'destroy_all',
      'delete_label',
      'delete_img',
      'query',
    ]),
    ...mapMutations('product', ['changeQuery', 'resetQuery']),
    ...mapActions('product', {
      productIndex: 'index',
    }),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.ai)
      } else if (this.formType === 'new') {
        await this.create(this.ai)
      }
      this.modalShow = false
    },
  }
}
</script>
